import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe274dfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "PartCollections",
  class: "mobile-part-collections-card mx-1"
}
const _hoisted_2 = { class: "mobile-part-collections-toolbar mb-3" }
const _hoisted_3 = { class: "is-size-6 has-text-weight-bold mb-1" }
const _hoisted_4 = { class: "control has-icons-left search-control" }
const _hoisted_5 = ["value", "placeholder"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-left fas fa-search" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "search-right-meta"
}
const _hoisted_8 = { class: "search-results-count has-text-grey" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "pb-2" }
const _hoisted_12 = ["id"]

import { ref, watch } from 'vue'
import PartCollectionBlock from './PartCollectionBlock.vue'
import BomAddToCartModal from '@/components/library/content/asset/viewer/illustrationViewer/bom/BomAddToCartModal.vue'

import type { DisplayCollection, PartRow } from '@/interfaces/library/partCollection'


export default /*#__PURE__*/_defineComponent({
  __name: 'MobilePartCollectionsLayout',
  props: {
    search: {},
    searchResultsCount: {},
    isSearching: { type: Boolean },
    isSearchMode: { type: Boolean },
    isExpandingAll: { type: Boolean },
    collections: {},
    columnWidths: {},
    contentWidth: {},
    effectivePartColumns: {},
    isCartOrErpCartEnabled: { type: Boolean },
    addToCartModalOpen: { type: Boolean },
    cartItem: {},
    isWidgetCartEnabled: { type: Boolean },
    hasHidePrice: { type: Boolean },
    hasMoreCollections: { type: Boolean },
    getExpanded: { type: Function },
    totalCount: {},
    isWidget: { type: Boolean }
  },
  emits: ["expand-all", "collapse-all", "search-input", "clear-search", "toggle-collection", "add-to-cart", "add-all-to-cart", "export-parts", "cart-submit", "close-cart-modal", "toggle-show-retail-price", "toggle-show-wholesale-price", "toggle-show-discount-price", "load-more"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const sentinel = ref<HTMLElement | null>(null)

watch(sentinel, (el, _, onCleanup) => {
  if (!el) return
  const observer = new IntersectionObserver(
    entries => { if (entries[0].isIntersecting) emit('load-more') },
    { threshold: 0.1 }
  )
  observer.observe(el)
  onCleanup(() => observer.disconnect())
})

__expose({ scrollRef: null })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(`${_ctx.$tc('partCollection', 2)} (${_ctx.totalCount})`), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("input", {
          value: _ctx.search,
          placeholder: `${_ctx.$t('searchContent', { content: _ctx.$tc('part', 2) })}...`,
          type: "text",
          class: "input search-input",
          onInput: _cache[0] || (_cache[0] = event => _ctx.$emit('search-input', event))
        }, null, 40, _hoisted_5),
        _hoisted_6,
        (_ctx.search)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.searchResultsCount) + " " + _toDisplayString(_ctx.$tc('result', _ctx.searchResultsCount)), 1),
              _createElementVNode("button", {
                type: "button",
                class: "search-clear-button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('clear-search')))
              }, _hoisted_10)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("section", _hoisted_11, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collections, (collection) => {
        return (_openBlock(), _createElementBlock("div", {
          id: `part-collection-${collection.id}`,
          key: collection.rowKey
        }, [
          _createVNode(PartCollectionBlock, {
            "can-add-all-to-cart": _ctx.isWidget ? _ctx.isWidgetCartEnabled : _ctx.isCartOrErpCartEnabled,
            collection: collection,
            "column-widths": _ctx.columnWidths,
            "content-width": _ctx.contentWidth,
            expanded: _ctx.getExpanded(collection),
            "is-expanding-all": _ctx.isExpandingAll,
            "is-search-mode": _ctx.isSearchMode,
            "is-searching": _ctx.isSearching,
            "part-columns": _ctx.effectivePartColumns,
            "has-hide-price": _ctx.hasHidePrice,
            "hide-thumbnail": true,
            "is-widget": _ctx.isWidget,
            style: {"margin-right":"0 !important"},
            onAddToCart: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('add-to-cart', $event))),
            onAddAllToCart: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('add-all-to-cart', $event))),
            onExportParts: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('export-parts', $event))),
            onToggle: ($event: any) => (_ctx.$emit('toggle-collection', collection.id)),
            onToggleShowRetailPrice: ($event: any) => (_ctx.$emit('toggle-show-retail-price', collection.id)),
            onToggleShowWholesalePrice: ($event: any) => (_ctx.$emit('toggle-show-wholesale-price', collection.id)),
            onToggleShowDiscountPrice: ($event: any) => (_ctx.$emit('toggle-show-discount-price', collection.id))
          }, null, 8, ["can-add-all-to-cart", "collection", "column-widths", "content-width", "expanded", "is-expanding-all", "is-search-mode", "is-searching", "part-columns", "has-hide-price", "is-widget", "onToggle", "onToggleShowRetailPrice", "onToggleShowWholesalePrice", "onToggleShowDiscountPrice"])
        ], 8, _hoisted_12))
      }), 128))
    ]),
    (_ctx.hasMoreCollections && !_ctx.isSearchMode)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "sentinel",
          ref: sentinel,
          class: "load-more-sentinel"
        }, null, 512))
      : _createCommentVNode("", true),
    (_ctx.addToCartModalOpen && !!_ctx.cartItem)
      ? (_openBlock(), _createBlock(BomAddToCartModal, {
          key: 1,
          "bom-item": _ctx.cartItem,
          "is-widget-cart-enabled": _ctx.isWidgetCartEnabled,
          onAddToCart: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('cart-submit', $event))),
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('close-cart-modal'))),
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('close-cart-modal')))
        }, null, 8, ["bom-item", "is-widget-cart-enabled"]))
      : _createCommentVNode("", true)
  ]))
}
}

})